
    
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
    import {useRouter, useRoute} from "vue-router";
    import {useStore} from "@/store";
    import { Dialog } from 'scvant';

    interface State {
        channelType: string;
        ecuInfo: object;
        normalNum: number;
        abnormalNum: number;
        isJiaGou: boolean;
        ecuId: string;
    }
    export default defineComponent({
        name: "EcuCheck",
        components: {
            [Dialog.Component.name]: Dialog.Component
        },
        setup() {
            let state: State = reactive({
                channelType: '',
                ecuInfo: {},
                normalNum: 0,
                abnormalNum: 0,
                isJiaGou: false,
                ecuId:'EcuInfo'
            })
            let store = useStore()
            // 获取路由器实例
            const router = useRouter()
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            // function isShowCurrentModel (checkModules: any,modelName: string): boolean {
            //     let containJiaGou = false;
            //     if (!checkModules) {
            //         containJiaGou = false;
            //     }
            //     for (let i=0;i<checkModules.length;i+=1) {
            //         if (checkModules[i].code === modelName) {
            //             containJiaGou = true;
            //         }
            //     }
            //     return containJiaGou;
            // }
            watch(reportData, (data: any) => {
                const {ecuInfo} = data;
                state.ecuInfo = ecuInfo || {};
                state.normalNum = ecuInfo ? ecuInfo.normalItems.length : 0;
                state.abnormalNum = ecuInfo ? ecuInfo.unNormalItems.length : 0;
                // state.isJiaGou = isShowCurrentModel(checkModules,'PlusEcuInfo');
                // state.ecuId = state.isJiaGou? 'PlusEcuInfo' : 'EcuInfo';
            }, {immediate: true})
            return {
                state,
                router
            }
        },
        methods: {
            toView(){
                this.router.push({
                    path: '/promiseFrameEcuDetail2503'
                })
            },
            failView(){
                Dialog.alert({
                    title: '查询失败',
                    message: '可能有以下原因导致ECU查询失败\n1.检测时无法读取行车电脑数据 \n2.该车辆不支持ECU检测',
                    messageAlign: 'left',
                    confirmButtonText: '我知道了'
                })
            }
        }
    })
